/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function SettingsIcon(props: IconProps) {
	const { color } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-991 -21)">
					<g transform="translate(0 1)">
						<path d="M1011 30a2.491 2.491 0 01-2.3 2.48 8.012 8.012 0 01-.511 1.232c.826.983.807 2.435-.118 3.359-.923.924-2.376.943-3.358.117a8.031 8.031 0 01-1.232.51A2.492 2.492 0 011001 40a2.492 2.492 0 01-2.48-2.301 8.009 8.009 0 01-1.233-.51c-.983.825-2.435.806-3.36-.118-.923-.924-.942-2.376-.116-3.359a7.982 7.982 0 01-.51-1.233A2.491 2.491 0 01991 30a2.492 2.492 0 012.302-2.48c.137-.429.306-.838.51-1.232-.826-.983-.807-2.435.117-3.36.924-.923 2.376-.942 3.359-.117a8.054 8.054 0 011.232-.51A2.491 2.491 0 011001 20a2.491 2.491 0 012.48 2.3c.43.14.84.307 1.233.511.982-.825 2.435-.806 3.358.118.925.924.944 2.376.118 3.359.204.394.372.803.51 1.232a2.492 2.492 0 012.302 2.48zm-3.24-1.25a6.796 6.796 0 00-1.108-2.634l.536-.535a1.25 1.25 0 00-1.768-1.768l-.54.54a6.836 6.836 0 00-2.63-1.102v-.75a1.25 1.25 0 10-2.5 0v.75a6.838 6.838 0 00-2.63 1.102l-.54-.54a1.25 1.25 0 10-1.767 1.768l.536.535a6.796 6.796 0 00-1.109 2.634h-.74a1.25 1.25 0 000 2.5h.74c.179.967.57 1.855 1.109 2.634l-.536.536a1.248 1.248 0 101.767 1.767l.54-.54a6.839 6.839 0 002.63 1.102v.75a1.25 1.25 0 102.5 0v-.75a6.837 6.837 0 002.63-1.101l.54.54a1.25 1.25 0 001.768-1.768l-.536-.536c.538-.779.93-1.667 1.109-2.634h.74a1.25 1.25 0 000-2.5h-.74zm-6.76 5a3.75 3.75 0 11.001-7.5 3.75 3.75 0 010 7.5zm0-6.25a2.5 2.5 0 100 5 2.5 2.5 0 000-5z" />
					</g>
				</StyledG>
			</g>
		</svg>
	);
}

export default SettingsIcon;
